import Vue from 'vue';
// import * as news from "../../../static/json/news.json"
// let news=null;
//模块：新闻资讯
export default Vue.extend({
    name: "n-com",
    data: function () {
        return {
            crtMenu: 'n1',
            newsList: null,
            crtIndex: 0,
            detailShow: false,
            news: null,
        };
    },
    beforeMount: function () {
        var _this = this;
        this.$http.get("./static/json/news.json").then(function (data) {
            if (data.status == 200) {
                _this.news = data.data;
                _this.transData();
            }
        });
    },
    mounted: function () {
    },
    methods: {
        /**
         * 功能：切换菜单
         * @param val
         */
        setMenu: function (val) {
            this.crtMenu = val;
        },
        /**
         * 功能：显示新闻列表
         */
        backList: function () {
            this.detailShow = false;
        },
        /**
         * 功能：显示新闻详情
         * @param index
         */
        toDetail: function (index) {
            this.crtIndex = index;
            this.detailShow = true;
        },
        transData: function () {
            var temp = this.news['news'];
            var url = "../../../static/img/news/";
            for (var _i = 0, _a = temp['n3']; _i < _a.length; _i++) {
                var item = _a[_i];
                item.img = item.img == "" ? "" : url + item.img;
                for (var _b = 0, _c = item.contents; _b < _c.length; _b++) {
                    var item1 = _c[_b];
                    item1.img = item1.img == "" ? "" : url + item1.img;
                }
            }
            this.newsList = temp;
        }
    },
    computed: {
        menuList: function () {
            return this.$t('newsmenu');
        },
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/news/n-com.vue
// module id = null
// module chunks = 